"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.memoize = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var hashesAreDifferent = function hashesAreDifferent(previous, current) {
  if ((0, _typeof2.default)(previous) != (0, _typeof2.default)(current)) {
    return true;
  }

  if (previous === undefined && current === undefined) {
    return false;
  }

  if (Array.isArray(previous) && Array.isArray(current) && previous.length === current.length) {
    return current.some(function (item, index) {
      return hashesAreDifferent(current[index], previous[index]);
    }) && current.length === previous.length; // return true if any (some) hashes are different
  }

  if (previous !== current) {
    return true;
  }
};
/**
 * Helper for memoization. Useful for optimizing duplicate renders.
 * @param {object} onObject where to store memoized data. `this` is a popular choice.
 * @param {string} name the name to store this memoized value under.
 * @param {function} getValue A function that get's the value that should be returned.
 * @param {*} hashBreaker Optional parameter that provides a manual mechanism to force updates via a "hash". The hashing logic also accepts an array of data (array is iterated through).
 */


var memoize = function memoize(onObject, name, getValue, hashBreaker) {
  onObject.memo = onObject.memo || {};

  if (!onObject.memo[name] || hashesAreDifferent(onObject.memo[name].hash, hashBreaker)) {
    onObject.memo[name] = {
      value: getValue(),
      hash: hashBreaker
    };
  }

  return onObject.memo[name].value;
};

exports.memoize = memoize;